import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/swiper-bundle';

document.addEventListener("DOMContentLoaded", () => {

    const mySwiper = new Swiper('.j-fvSlider', {
      effect: "fade",
      fadeEffect: { crossFade: false },
      speed: 200, // 0.2秒で切り替え
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });



  gsap.registerPlugin(ScrollTrigger);

  const fv = document.querySelector(".p-rcareer_fv");
  const fvPin = document.querySelector(".j-rcareer_fv_pin");
  const fvTriger = document.querySelector(".j-rcareer_fv_trigerend");
  const fvWrap = document.querySelector(".j-rcareer_fv_wrap");
  // let nextanimation = document.querySelector(".p-rcareer_fv");
  ScrollTrigger.create({
    trigger: fvTriger,
    start: "top top",
    end: "bottom top",
    // end: "+=50%",
    pin: fvPin,
    // markers: true,
  });
  gsap.to(fvWrap, {
    maskImage: "linear-gradient(225deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 0%, transparent 0%, transparent 100%)",
    duration: 1.0,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: fvTriger,
      start: "+=20% top",
      scrub: false,
      toggleActions: "play none none reverse",
      // markers: true,
      onEnter: () => {
        setTimeout(() => {
          // document.querySelector(".j-rcareer_story_cont").classList.add("active");
          // // document.querySelector(".p-rcareer_persons_head_subttl").classList.add("active");
          // // document.querySelector(".p-rcareer_persons_slider").classList.add("active");
          document.querySelector(".p-rcareer_persons_head_ttl").classList.add("active");
          document.querySelector(".p-rcareer_persons_head_subttl").classList.add("active");
          document.querySelector(".p-rcareer_persons_list").classList.add("active");
          // story.classList.add("u-pointer-none");
          fv.classList.add("u-pointer-none");
        }, 1000);
      },
      onLeaveBack: () => {
        setTimeout(() => {
          fv.classList.remove("u-pointer-none");
        }, 1000);
      }
    },

  });

  // const story = document.querySelector(".p-rcareer_story");
  // const storyPin = document.querySelector(".j-rcareer_story_pin");
  // const storyTriger = document.querySelector(".j-rcareer_story_trigerend");
  // const storyWrap = document.querySelector(".j-rcareer_story_wrap");
  // const storyBg = document.querySelector(".j-rcareer_story_bg");
  // const storyCont = document.querySelector(".j-rcareer_story_cont");
  // // const storyContTr = document.querySelector(".j-rcareer_story_triger");


  // // ==============================
  // // 1）上部で固定（スクロール中に動く）
  // // ==============================
  //   const scrollHeight = storyCont.scrollHeight;


  //   gsap.to(storyCont, {
  //     y: () => -scrollHeight,
  //     ease: "none",
  //     scrollTrigger: {
  //       trigger: story,
  //       start: "+=100% top",
  //       end: () => `+=${scrollHeight}`,
  //       scrub: true,
  //     }
  //   });
  //   ScrollTrigger.create({
  //     trigger: storyTriger,
  //     start: "top top",
  //     end: "+=100% top",//トリガーの高さを追加するcss
  //     pin: storyPin,
  //   });


  // gsap.to(storyPin, {
  //   clipPath: "polygon(50% 0%, 100% 0%, 100% 0%, 50% 0%, 50% 100%, 0 100%, 0% 100%, 50% 100%)",
  //   duration: 0.3,
  //   ease: "power2.inOut",
  //   scrollTrigger: {
  //     trigger: storyTriger,
  //     start: "+=100% bottom",
  //     // end: "bottom bottom",
  //     // end: "+=20%",
  //     // start: () => `+=${story.offsetHeight}`,
  //     scrub: false,
  //     toggleActions: "play none none reverse",
  //     // markers: true,
  //     // pin: story,
  //     onEnter: () => {
  //       setTimeout(() => {
  //         document.querySelector(".p-rcareer_persons_head_ttl").classList.add("active");
  //         document.querySelector(".p-rcareer_persons_head_subttl").classList.add("active");
  //         document.querySelector(".p-rcareer_persons_list").classList.add("active");
  //         story.classList.add("u-pointer-none");
  //       }, 300);
  //     },
  //     onLeaveBack: () => {
  //       setTimeout(() => {
  //         story.classList.remove("u-pointer-none");
  //       }, 300);
  //     }
  //   },
  // });


  const persons = document.querySelector(".p-rcareer_persons");
  const personsPin = document.querySelector(".j-rcareer_persons_pin");
  const personsTriger = document.querySelector(".j-rcareer_persons_trigerend");
  const personsWrap = document.querySelector(".j-rcareer_persons_wrap");
  ScrollTrigger.create({
    trigger: personsTriger,
    start: "top top",
    end: "+=150% top",
    pin: personsPin,
    // markers: true,
  });

});


const isMobile = window.matchMedia("(max-width: 768px)").matches;

if(!isMobile) {
  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      location.reload();
    }, 500); // ← 0.5秒後にリロード
  });
}